export const extractAccessTokenFromOAuthBody = (data: unknown): string | null => {
  if (!data || typeof data !== 'object') {
    return null
  }
  const token = (data as { access_token?: unknown }).access_token
  return typeof token === 'string' && token.length > 0 ? token : null
}
